import {fetchSubStations} from "../network/PickNetworkAPI";
import {getPickColumnsKey, PICK_FILTER_STATE_KEY} from "../../util/LocalStorageKeys";
import {getFromLocalStorage, readFilterState, saveFilterState, saveIntoLocalStorage} from "../../util/Util";
import {BOOLEAN} from "../../util/Constants";

export const PickFilterReducer = (state, action) => {
    switch (action.type) {
        case "RECEIVE_FILTER_DATA": {
            const newState = {...state, data: {...state.data, ...action.data}}
            saveFilterState(PICK_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "LOAD_XPT_NODES": {
            const {dispatcher, baseUrl, capability, stationConfig} = action.data;
            fetchSubStations(dispatcher, baseUrl, capability, stationConfig);
            return state;
        }
        case "RECEIVE_XPT_NODES": {
            const {xptNodes} = action.data;
            const savedState = readFilterState(PICK_FILTER_STATE_KEY);
            let newState = {...state, xptNodes, data: {...state.data, xptNodes}};
            if (savedState) {
                newState = {...state, data: {...state.data, xptNodes}};
            }
            saveFilterState(PICK_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_XPT_NODE": {
            const newState = {...state, xptNodes: action.xptNodes}
            saveFilterState(PICK_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_CLUSTER": {
            const newState = {...state, cluster: action.Cluster}
            saveFilterState(PICK_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_STATUS": {
            const newState = {...state, status: action.status}
            saveFilterState(PICK_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_ROUTE_STATUS": {
            const newState = {...state, routeStatus: action.routeStatus}
            newState["picklistStatus"] = [];
            saveFilterState(PICK_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_WORKSTATION_STATUS": {
            const newState = {...state, workstationStatus: action.workstationStatus}
            saveFilterState(PICK_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_PICK_STATION": {
            const newState = {...state, pickWorkstations: action.pickWorkstations}
            saveFilterState(PICK_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_PICKLIST_STATUS": {
            const newState = {...state, picklistStatus: action.picklistStatus}
            newState["routeStatus"] = [];
            saveFilterState(PICK_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_SPR_TIME_LIMIT": {
            const newState = {...state, sprTimeLimit: action.sprTimeLimit}
            saveFilterState(PICK_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_SPR_PACKAGE_COUNT": {
            const newState = {...state, sprPackageCount: action.sprPackageCount}
            saveFilterState(PICK_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_ROUTE_SPR": {
            let newState;
            if (action.highSPREnabled) {
                newState = {...state, routeSPR: ["High SPR"]}
            } else {
                newState = {...state, routeSPR: []}
            }
            saveFilterState(PICK_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_RC_TIME_LIMIT": {
            const newState = {...state, rcTimeLimit: action.rcTimeLimit}
            saveFilterState(newState);
            return newState
        }
        case "SELECT_RC_PACKAGE_COUNT": {
            const newState = {...state, rcPackageCount: action.rcPackageCount}
            saveFilterState(newState);
            return newState;
        }
        case "SELECT_AT_RISK": {
            let newState;
            if (action.atRiskEnabled) {
                newState = {...state, atRisk: [BOOLEAN.TRUE]}
            } else {
                newState = {...state, atRisk: []}
            }
            saveFilterState(PICK_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_MULTI_STATION_PICKLIST": {
            let newState;
            if (action.multiStationPicklistEnabled) {
                newState = {...state, multiStationPicklists: [BOOLEAN.TRUE]}
            } else {
                newState = {...state, multiStationPicklists: []}
            }
            saveFilterState(PICK_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_DRIVER_TYPE": {
            const newState = {...state, driverType: action.DriverType}
            saveFilterState(PICK_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SET_PICK_COLUMNS": {
            const pickColumnsKey = getPickColumnsKey(action.data.capability);
            const selectedCols = action.data.newValue ? action.data.newValue : [];
            saveIntoLocalStorage(pickColumnsKey, JSON.stringify(selectedCols));
            return {...state, selectedPickColumns: selectedCols}
        }
        case "LOAD_PICK_COLUMNS": {
            try {
                const pickColumnsKey = getPickColumnsKey(action.data.capability);
                const storedJson = getFromLocalStorage(pickColumnsKey) || null;
                if (storedJson != null) {
                    return {...state, selectedPickColumns: JSON.parse(storedJson)}
                }
            } catch (e) {
            }
            return state;
        }
        case "SELECT_DEPARTURE": {
            const newState = {...state, departure: action.Departure}
            saveFilterState(PICK_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_PICK_BY_TIME": {
            const newState = {...state, pickByTime: action.PickByTimes}
            saveFilterState(PICK_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_AISLE_GROUP_STATUS": {
            const newState = {...state, aisleGroupStatus: action.aisleGroupStatus};
            saveFilterState(PICK_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_PICKLIST_STATUS_IN_GRID": {
            const newState = {...state, picklistStatusInGrid: action.picklistStatusInGrid};
            saveFilterState(PICK_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "SELECT_WAVE_PLUS_X": {
            let newState;
            if (action.wavePluxXEnabled) {
                newState = {...state, wavePluxXEnabled: [BOOLEAN.TRUE]}
            } else {
                newState = {...state, wavePluxXEnabled: []}
            }
            saveFilterState(PICK_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "UNLOAD_VIEW":
            return state;
        case "REMOVE_FILTER": {
            const {key, value} = action.data
            state[key] = state[key].filter(item => item !== value)
            const newItem = state[key].filter(item => item !== value)
            const newState = {...state, [key]: newItem}
            saveFilterState(PICK_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "REMOVE_ALL_FILTER": {
            const newState = {...state};
            Object.entries(state).forEach(entry => {
                const key = entry[0];
                const values = entry[1];
                if (Array.isArray(values) && values.length && key !== 'data' && key !== 'selectedPickColumns') {
                    newState[key] = [];
                }
            });
            saveFilterState(PICK_FILTER_STATE_KEY, newState);
            return newState;
        }
        case "LOAD_FILTERS": {
            const savedState = readFilterState(PICK_FILTER_STATE_KEY);
            if (savedState) {
                return {
                    ...state,
                    ...savedState,
                    selectedPickColumns: state.selectedPickColumns
                }
            }
            return state;
        }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/pickStatus/reducers/PickFilterReducer.js